import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import RegionSidebar from 'components/RegionSidebar';
import RegionEditTabs from 'components/RegionEditTabs';

import { withData } from 'lib';
import { SettingsRegionEditPageQuery } from '__generated__/SettingsRegionEditPageQuery.graphql';

const query = graphql`
  query SettingsRegionEditPageQuery(
    $id: ID!
    $search: String
    $first: Int!
    $after: String
  ) {
    region(id: $id) {
      name

      country {
        id
        name
      }

      ...RegionEditTabs_region
      ...RegionSidebar_region
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsRegionEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/countries', name: 'Vietos' },
];

const SettingsRegionEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { region } = usePreloadedQuery<SettingsRegionEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!region) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<RegionSidebar region={region} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          link: `/settings/countries/${region.country.id}#regions`,
          name: region.country.name,
        },
        { name: region.name },
      ]}>
      <RegionEditTabs region={region} />
    </PageWithSidebar>
  );
};

export default withData<SettingsRegionEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams, currentUser }) => ({
    id: routeParams.id,
    first: currentUser.itemsPerPage,
  }),
})(SettingsRegionEditPage);
